<template>
  <div class="container visit-time">
    <div class="form-group visit-buttons-group" v-if="serviceId || dataValue.service_types === 'T_OUTSIDE'">
      <d-button
        class="visit-button"
        outline
        :disabled="disableDate"
        style="width: 25%;"
        :theme="themeButtons"
        @click.prevent.stop="openCalendar">
        <template v-if="!spinnerHourEdit"><i class="material-icons ml-1 mt-1" style="margin-bottom: 0.7rem">date_range</i><span class="ml-2">Sprawdź terminy dla dnia</span></template>
        <template v-else>
          <div class="spinner-border spinner-border-sm" style="margin-bottom: 0.45rem; margin-top: 0.45rem" role="status"></div>
        </template>
      </d-button>
      <p class="mt-3 ml-4 mr-2" style="font-weight: 100">LUB</p>
      <d-button
        outline
        :disabled="disableDate"
        style="width: 25%; white-space: nowrap !important;"
        class="ml-3 visit-button"
        :theme="themeButtons"
        @click.prevent.stop="checkAvailableHours(1)">
        <template v-if="!spinnerDays"><i class="material-icons mr-1 mt-1" style="margin-bottom: 0.7rem">access_time</i><span class="ml-2">Pokaż najbliższe wolne terminy</span></template>
        <template v-else>
          <div class="spinner-border spinner-border-sm" style="margin-bottom: 0.45rem; margin-top: 0.45rem" role="status"></div>
        </template>
      </d-button>
    </div>
    <d-modal
      v-if="showCalendar"
      @close="closeCalendar"
      class="visit-calendar-modal"
      style="background-color: rgba(0,0,0,0.7)!important;">
      <d-modal-header>
      </d-modal-header>
      <d-modal-body>
        <div class="visit-calendar-modal-body">
          <visits-calendar
            v-if="showCalendar"
            :current-month="currentMonthDays"
            :date="currentDate"
            :date-name="dayNames"
            :first-month-day="firstMonthDay"
            :month="month"
            :prev-month="prevMonthDays"
            :prev-month-days="prevMonth"
            :weekday-name="weekDayNames"
            :weekdays="weekdays"
            :single-shift="singleShift"/>
        </div>
        <div class="visit-calendar-modal-group">
          <d-button
            style="width: 100%;"
            class="ml-3"
            :theme="'info'"
            @click.prevent.stop="checkAvailableHours(0)">
            <template v-if="!spinnerHours"><i class="material-icons mr-1 mt-1" style="margin-bottom: 0.7rem">access_time</i><span class="ml-2">Zastosuj</span></template>
            <template v-else>
              <div class="spinner-border spinner-border-sm" style="margin-bottom: 0.45rem; margin-top: 0.45rem" role="status"></div>
            </template>
          </d-button>
        </div>
      </d-modal-body>
    </d-modal>
    <d-card class="mb-5 p-5 mt-4" style="background-color: rgb(243 243 243);" v-if="selectHourBox">
      <d-row class="border-bottom" style="justify-content: center; margin: 0.75rem 2rem;">
        <h4 class="page-subtitle deadlines">Najbliższe wolne terminy</h4>
      </d-row>
      <div :class="['visits-container', disableOptions ? 'shadow-layer' : '']">
        <div class="visits-tab" :key="aIndex" v-if="list" v-for="(list, aIndex) in availableDays">
          <span class="visit-title">Wolne terminy dnia:</span>
          <div class="visit-title-box">
            <span>{{list.date.slice(8, 10)}}</span>
            <span>{{list.date.slice(5, 7) === '01' ? 'Styczeń' : (list.date.slice(5, 7) === '02' ? 'Luty' : (list.date.slice(5, 7) === '03' ? 'Marzec' : (list.date.slice(5, 7) === '04' ? 'Kwiecień' : (list.date.slice(5, 7) === '05' ? 'Maj' : (list.date.slice(5, 7) === '06' ? 'Czerwiec' :
            (list.date.slice(5, 7) === '07' ? 'Lipiec' : (list.date.slice(5, 7) === '08' ? 'Sierpień' : (list.date.slice(5, 7) === '09' ? 'Wrzesień' : (list.date.slice(5, 7) === '10' ? 'Październik' : (list.date.slice(5, 7) === '11' ? 'Listopad' : 'Grudzień'))))))))))}}</span>
            <span>{{list.date.slice(0, 4)}}</span>
          </div>
          <div :key="bIndex" v-for="(data, bIndex) in list">
            <div class="pb-3 pt-3 text-center" v-if="!list.hours.length">
              <h4 class="text-danger">{{data.reason}}</h4>
            </div>
            <div
              :class="['visit-hours-box', (selectHourNext === true && selectHourIndex === cIndex ) ? 'visit-hours-select' : '']"
              :key="cIndex"
              v-for="(i, cIndex) in data.hour"
              v-if="i.users">
              <d-badge theme="danger" v-if="selectHourIndexNextBase === aIndex && selectHourIndexNext === cIndex && selectHourIndexNextErr === true">!</d-badge>
              <h4>{{i.hour}}</h4>
              <div :class="[ 'form-control', 'is-select', (selectHourIndexNextBase === aIndex && selectHourIndexNext === cIndex && selectHourIndexNextErr === true) ? 'error_border' : '' ]">
                <v-select
                  :disabled="disableOptions"
                  :ref="'select-' + aIndex + '-' + cIndex"
                  :key="'selector-' + aIndex + '-' + cIndex"
                  :options="i.users"
                  v-model="userId"
                  :reduce="user => user.id"
                  placeholder="Wybierz specjalistę"
                  label="id">
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.name }} {{ option.last_name }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name }} {{ option.last_name }}
                    </div>
                  </template>
                </v-select>
              </div>
              <d-button
                :disabled="disableOptions"
                :name="'button-' + aIndex + '-' + cIndex"
                style="margin-left: 2rem"
                :theme="(selectHourIndexNextBase === aIndex && selectHourIndexNext === cIndex && selectHourIndexNextErr === true ) ? 'danger' : (selectHourIndexNextBase === aIndex && selectHourIndexNext === cIndex && selectHourIndexNextErr !== true ) ? 'primary' : 'light'"
                @click.prevent="selectReservationDate(list.date, i.hour, aIndex, cIndex, 'next', 'select-' + aIndex + '-' + cIndex)">
                <i class="material-icons mr-1 mt-1" style="margin-bottom: 0.7rem">{{(selectHourIndexNextBase === aIndex && selectHourIndexNext === cIndex && selectHourIndexNextErr === true) ? 'person' : (selectHourIndexNextBase === aIndex && selectHourIndexNext === cIndex && selectHourIndexNextErr !== true ) ? 'done' : 'access_time'}}</i>
                Wybieram
              </d-button>
            </div>
          </div>
        </div>
        <div class="pb-3 pt-3 text-center" v-if="!availableDays[0]">
          <h4 class="no-visit">W najbliższym czasie nie ma żadnych wolnych terminów…&hellip;</h4>
        </div>
      </div>
    </d-card>
    <d-card class="mb-5 p-5 mt-4" style="background-color: rgb(243 243 243);" v-if="selectHourDay">
      <d-row class="border-bottom" style="justify-content: center;">
        <div :class="['header__title', 'visit_title_date', disableOptions || disableDate ? 'shadow-layer' : '']">
          <d-button :disabled="disableOptions || disableDate" class="header__title_button" @click.prevent="dateDown" theme="light">
            <i class="material-icons">keyboard_arrow_left</i>
          </d-button>
          <p :class="['header__title_text', dayNames[0].name === currentDay ? ( currentDay.slice(9) !== 'Niedziela' ? 'header__title_text_active' : '') : '', dayNames[0].name.slice(8) === 'niedziela' ? 'header__title_text_closed' : '']">
            {{dayNames[0].name}}
          </p>
          <d-button :disabled="disableOptions || disableDate" class="header__title_button" @click.prevent="dateUp" theme="light">
            <i class="material-icons">keyboard_arrow_right</i>
          </d-button>
        </div>
        <d-button
          outline
          class="change-date-button"
          v-if="isEdit && disableDate"
          theme="danger"
          @click.prevent="getCurrentDateEdit">
          <i class="material-icons mr-1">history</i>
          Zmień datę
        </d-button>
      </d-row>
      <div :class="['visits-container', disableOptions ? 'shadow-layer' : '', classDays ? 'visits-container-overflow' : '']">
        <div :class="['visit-hours-box', (selectHourNext === true && selectHourIndex === index ) ? 'visit-hours-select' : '']" :key="index" v-for="(list, index) in availableHours.hour" v-if="list.hour">
          <d-badge theme="danger" v-if="selectHourIndexNext === index && selectHourIndexNextErr === true">!</d-badge>
          <h4>{{list.hour}}</h4>
          <div :class="[ 'form-control', 'is-select', (selectHourIndexNextBase === index && selectHourIndexNextErr === true) ? 'error_border' : '' ]">
            <v-select
              :disabled="disableOptions"
              :ref="'select-hour-' + index"
              :key="'selector-' + index + keySelect"
              :options="list.users"
              :reduce="user => user.id"
              v-model="userId"
              :placeholder="indexEditData && (indexEditData.toString() === index.toString()) ? userName : 'Wybierz specjalistę'"
              label="id">
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.name }} {{ option.last_name }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.name }} {{ option.last_name }}
                </div>
              </template>
            </v-select>
          </div>
          <d-button
            :key="keySelect"
            :disabled="disableOptions"
            :name="'button-' + index"
            style="margin-left: 2rem"
            :theme="(selectHourIndexNext === index && selectHourIndexNextErr === true ) ? 'danger' : ((selectHourIndexNext === index && selectHourIndexNextErr !== true ) || (indexEditData ? (indexEditData.toString() === index.toString()) : '')) ? 'primary' : 'light'"
            @click.prevent="selectReservationDate(startDate, list.hour, index, index, 'hours', 'select-hour-' + index)">
            <i class="material-icons mr-1 mt-1" style="margin-bottom: 0.7rem">{{(selectHourIndexNext === index && selectHourIndexNextErr === true) ? 'person' : ((selectHourIndexNext === index && selectHourIndexNextErr !== true) || (indexEditData ? (indexEditData.toString() === index.toString()) : '')) ? 'done' : 'access_time'}}</i>
            Wybieram
          </d-button>
        </div>
        <div class="pb-3 pt-3 text-center" v-if="!availableHours.hour.length">
          <h4 class="text-danger">{{availableHours.reason}}</h4>
        </div>
      </div>
    </d-card>
    <div id="button-accept" v-if="data.date && data.hour && !selectHourIndexNextErr">
      <div class="visits-edit-value add-value">
        Wybrana data: <span>{{data.date.slice(8, 10) + ' '}}</span>
        <span>{{data.date.slice(5, 7) === '01' ? 'Styczeń' : (data.date.slice(5, 7) === '02' ? 'Luty' : (data.date.slice(5, 7) === '03' ? 'Marzec' : (data.date.slice(5, 7) === '04' ? 'Kwiecień' : (data.date.slice(5, 7) === '05' ? 'Maj' : (data.date.slice(5, 7) === '06' ? 'Czerwiec' :
          (data.date.slice(5, 7) === '07' ? 'Lipiec' : (data.date.slice(5, 7) === '08' ? 'Sierpień' : (data.date.slice(5, 7) === '09' ? 'Wrzesień' : (data.date.slice(5, 7) === '10' ? 'Październik' : (data.date.slice(5, 7) === '11' ? 'Listopad' : 'Grudzień')))))))))) + ' '}}</span>
        <span> {{data.date.slice(0, 4)}}</span>, wybrana godzina: <span>{{data.hour}}</span>
      </div>
    </div>
    <d-button
      v-if="data.date && data.hour && !selectHourIndexNextErr && (patientPopup ? data.last_name : data.hour)"
      class="visit-send"
      @click.prevent="submitForm"
      theme="success">
      {{ isEdit ? 'Aktualizuj wizytę' : 'Dodaj wizytę'}}
    </d-button>
    <d-button
      v-if="data.date && data.hour && !selectHourIndexNextErr && patientPopup && !popupDate"
      class="visit-send mt-2"
      :outline="!!(data.phone && data.pesel && data.name && data.last_name)"
      @click.prevent="openCalendarPatient"
      :theme="(data.phone && data.pesel && data.name && data.last_name) ? 'dark' : 'danger'">
      {{ (!data.phone && !data.pesel && !data.name && !data.last_name) ? 'Dodaj pacjenta' : 'Zmień pacjenta'}}
    </d-button>
    <d-modal
      v-if="showCalendarPatient"
      @close="closeCalendarPatient"
      class="visit-patient-modal"
      style="background-color: rgba(0,0,0,0.7)!important;">
      <d-modal-header>
        <d-modal-title class="mt-3 mb-3">
          <h4 class="page-subtitle">Dane pacjenta </h4>
        </d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div class="visit-patient-modal-body">
          <d-card class="mb-5 p-3 mt-4" style="background-color: rgb(243 243 243);">
            <visits-form-patient-popup
              v-if="data.patient_id"
              :on-close-popup="closeModalPatientInfo"
              :is-visible="isModalPatientInfoVisible"
              :patient-id="data.patient_id"
              :visit-id="data.id || 0"
              :visit-form="isEdit"/>

            <div class="form-group visit-custom-group">
              <div class="form-group">
                <validation-provider
                  name="parent_id"
                  class="visit-patient-box"
                  v-slot="{ errors }"
                >
                  <label for="patient_id" class="visit-patient-box-label">Wyszukaj pacjenta: <span style="color: #c4183c">*</span></label>
                  <patient-suggestion-filter
                    :key="'patient-suggestion-' + componentKey"
                    v-model="data.patient_id"
                    style="width: 80%;"
                    :endpoint-items="'/patients/items'"
                    :data-id="data.patient_id"
                    :reduce="obj => obj.id"
                    :endpoint-item="'/patients/item/'"
                    :placeholder="'Wybierz pacjenta z listy lub filtruj po imieniu lub nazwisku...'"
                  />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <validation-provider
                  name="parent_id"
                  v-slot="{ errors }"
                  class="visit-patient-box"
                >
                  <label for="name" class="visit-patient-box-label">Imię:</label>
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <validation-provider
                  name="parent_id"
                  v-slot="{ errors }"
                  class="visit-patient-box"
                >
                  <label for="last_name" class="visit-patient-box-label">Nazwisko:</label>
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.last_name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <validation-provider
                  name="parent_id"
                  v-slot="{ errors }"
                  class="visit-patient-box"
                >
                  <label for="pesel" class="visit-patient-box-label">Pesel:</label>
                  <d-input
                    type="number"
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.pesel" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <validation-provider
                  name="parent_id"
                  v-slot="{ errors }"
                  class="visit-patient-box"
                >
                  <label for="phone" class="visit-patient-box-label">Numer telefonu:</label>
                  <d-input
                    type="number"
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.phone" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </div>
          </d-card>
          <div class="button-end">
            <d-button
              class="button-end-patient"
              :theme="(data.phone && data.pesel && data.name && data.last_name) ? 'success' : 'secondary'"
              @click.prevent="closeCalendarPatient">
              {{(data.phone && data.pesel && data.name && data.last_name) ? 'Akceptuj' : 'Zamknij'}}
            </d-button>
          </div>
        </div>
      </d-modal-body>
    </d-modal>
    <d-modal
      class="visits__popup visit-form-popup"
      v-if="showModalSummary"
      @close="closeSummary"
      style="background-color: rgba(0,0,0,0.6)!important;">
      <d-modal-header>
        <d-modal-title class="visits-summary-head">
          {{modalHeadText}}
        </d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div class="visits__popup_content">
          <div class="visits__popup_content_box">
            Data: <span>{{dayNames[0].name.slice(8) + ', '}}</span><span>{{data.date.slice(8, 10) + ' '}}</span>
            <span>{{data.date.slice(5, 7) === '01' ? 'Styczeń' : (data.date.slice(5, 7) === '02' ? 'Luty' : (data.date.slice(5, 7) === '03' ? 'Marzec' : (data.date.slice(5, 7) === '04' ? 'Kwiecień' : (data.date.slice(5, 7) === '05' ? 'Maj' : (data.date.slice(5, 7) === '06' ? 'Czerwiec' :
          (data.date.slice(5, 7) === '07' ? 'Lipiec' : (data.date.slice(5, 7) === '08' ? 'Sierpień' : (data.date.slice(5, 7) === '09' ? 'Wrzesień' : (data.date.slice(5, 7) === '10' ? 'Październik' : (data.date.slice(5, 7) === '11' ? 'Listopad' : 'Grudzień')))))))))) + ' '}}</span>
            <span>{{data.date.slice(0, 4)}}</span>
          </div>
          <div class="visits__popup_content_box">
            Godzina: <span>{{data.hour ? data.hour : ''}}</span>
          </div>
          <div class="visits__popup_content_box">
            Usługa: <span>{{service.name}}</span>
          </div>
          <div class="visits__popup_content_box">
            Specjalista: <span>{{data.user_name}}</span>
          </div>
          <div class="visits__popup_content_box">
            Placówka: <span>{{institution.name}}</span>
          </div>
          <div class="visits__popup_content_box" v-if="!patientPopup">
            Pacjent: <span>{{dataValue.name}} {{dataValue.last_name}}</span>
          </div>
          <div class="visits__popup_content_box" v-if="patientPopup">
            Pacjent: <span>{{data.name}} {{data.last_name}}</span>
          </div>
          <div class="visits__popup_content_box" v-if="!patientPopup">
            PESEL: <span>{{dataValue.pesel}}</span>
          </div>
          <div class="visits__popup_content_box" v-if="patientPopup">
            PESEL: <span>{{data.pesel}}</span>
          </div>
          <div class="visits__popup_content_box" v-if="!patientPopup">
            Telefon: <span>{{dataValue.phone}}</span>
          </div>
          <div class="visits__popup_content_box" v-if="patientPopup">
            Telefon: <span>{{data.phone}}</span>
          </div>
          <div class="visits__popup_content_box" v-if="!patientPopup">
            E-mail: <span>{{dataValue.email ? dataValue.email : 'Brak'}}</span>
          </div>
          <div class="visits__popup_content_box" v-if="patientPopup">
            E-mail: <span>{{data.email ? data.email : 'Brak'}}</span>
          </div>
        </div>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="submitForm(reservationId ? 'reservation' : '')">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="closeSummary">
            Anuluj
          </d-button>
        </div>
      </d-modal-body>
    </d-modal>
  </div>
</template>

<script>
import FilterSelect from '../../others/FilterSelect';
import DatePicker from 'vue2-datepicker';
import VisitsCalendar from '../../../views/visits/VisitsCalendar.vue';
import CalendarUtils from '../../../utils/CalendarUtils';
import FormUtils from '../../../utils/FormUtils.js';
import PatientSuggestionFilter from '../../others/PatientSuggestionFilter';
import VisitsFormPatientPopup from './VisitsFormPatientPopup';

export default {
  name: 'visits-date-of-the-visit',
  components: {
    FilterSelect, DatePicker, VisitsCalendar, PatientSuggestionFilter, VisitsFormPatientPopup
  },
  data () {
    return {
      data: {
        user_id: '',
        user_name: '',
        date: '',
        hour: '',
        patient_id: 0,
        name: '',
        last_name: '',
        pesel: '',
        phone: '',
        duration: 0,
        number_of_people: ''
      },
      dateModal: false,
      downloading: false,
      selectHourBox: false,
      selectHourNext: false,
      selectHourDay: false,
      showCalendar: false,
      disableOptions: false,
      spinnerHours: false,
      spinnerDays: false,
      showModalSummary: false,
      selectHourNextDay: false,
      spinnerHourEdit: false,
      disableDate: false,
      classDays: false,
      isModalPatientInfoVisible: false,
      textOpenModal: false,
      showCalendarPatient: false,
      selectHourIndex: 0,
      componentKey: 0,
      selectHourIndexNextBase: '',
      selectHourIndexNext: '',
      userName: '',
      selectHourIndexNextErr: false,
      keySelect: 0,
      componentUserKey: 0,
      containerKey: 0,
      indexEditData: null,
      daysCount: 1,
      availableDays: [],
      availableHours: [],
      institution: [],
      service: [],
      patient: [],
      users: [],
      month: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień', '', ''],
      weekDayNames: ['Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota', 'Niedziela'],
      monthShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru', '', ''],
      weekdays: ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'Nd'],
      monthNumber: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '', ''],
      dayNumber: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '', ''],
      firstDayPrev: '',
      day: '',
      dayPrev: '',
      currentDate: {
        date: 0,
        month: 0,
        year: 0,
        yearAdd: 0
      },
    }
  },
  props: {
    itemsWhere: {
      type: String
    },
    medicalId: {
      type: [Number, String],
      required: true
    },
    userId: {
      type: [String, Number],
      required: true
    },
    serviceId: {
      type: [String, Number],
      required: true
    },
    patientId: {
      type: [String, Number],
      required: true
    },
    duration: {
      type: [String, Number]
    },
    closeModal: {
      type: Function
    },
    institutionId: {
      type: [String, Number],
      required: true
    },
    numberOfPeople: {
      type: [String, Number],
      required: true
    },
    dataValue: {
      type: [Object, Array],
      required: true
    },
    popupDate: {
      type: Boolean,
      default: false
    },
    popupDateStart: {
      type: Boolean,
      default: true
    },
    popupClose: {
      type: Function
    },
    popupCloseDate: {
      type: Function
    },
    reload: {
      type: Function
    },
    singleShift: {
      type: Boolean,
      default: false
    },
    patientPopup: {
      type: Boolean,
      default: false,
    },
    reservationPatient: {
      type: [Array, Object]
    },
    reservationId: {
      type: [String, Number]
    },
    themeButtons: {
      type: String,
      default: 'info'
    },
    modalHeadText: {
      type: String,
      default: 'Potwierdź wizytę'
    }
  },
  created () {
    this.getCurrentDate();
    this.getFirstDay();
  },
  mounted () {
    setTimeout(() => {
      if (this.isEdit && this.dataValue) {
        this.disableDate = true;
        this.disableOptions = true;
        this.spinnerHourEdit = true;
        this.editUser();
        setTimeout(() => {
          this.checkAvailableHoursEdit();
        }, 800);
      }
    }, 500);
  },
  watch: {
    'data.pesel': function (value) {
      if (this.patient && value !== this.patient.pesel && !this.reservationPatient) {
        if (!this.dataValue) {
          this.clearPatientData();
        }
        this.componentKey += 1;
      }
    },
    'data.phone': function (value) {
      if (this.patient && value !== this.patient.phone && !this.reservationPatient) {
        if (!this.dataValue) {
          this.clearPatientData();
        }
        this.componentKey += 1;
      }
    },
    'data.name': function (value) {
      if (this.patient && value !== this.patient.name && !this.reservationPatient) {
        if (!this.dataValue) {
          this.clearPatientData();
        }
        this.componentKey += 1;
      }
    },
    'data.last_name': function (value) {
      if (this.patient && value !== this.patient.last_name && !this.reservationPatient) {
        if (!this.dataValue) {
          this.clearPatientData();
        }
        this.componentKey += 1;
      }
    },
    'data.patient_id': function (id) {
      if (id) {
        this.checkValueForModal();
        if (this.patient_id > 0 && !this.reservationPatient && !this.reservationPatient.id) {
          this.singlePatient(id);
        }
      }
    },
    'data.user_id': function () {
      this.componentUserKey += 1;
    },
    'userId': function (value) {
      if ((value !== this.data.user_id) && this.data.user_id && this.isEdit) {
        this.indexEditData = null;
        this.getCurrentDateEdit();
        setTimeout(() => {
          this.spinnerHourEdit = true;
          this.checkAvailableHours(0);
        }, 200)
      }
      if ((value === this.data.user_id) && this.isEdit) {
        this.indexEditData = null;
        this.getCurrentDateEdit();
        setTimeout(() => {
          this.spinnerHourEdit = true;
          this.checkAvailableHoursEdit();
        }, 200)
      }
    },
    'currentDate.yearAdd': function () {
      this.firstDayInLastMonth();
      this.checkTheMonthNumber();
      this.checkSundays();
      this.getFirstDay();
    },
    'data.date': function () {
      this.getInstitution();
      this.getService();
    },
    'currentDate.date': function () {
      this.checkTheMonthNumber();
      this.checkSundays();
    },
    'currentDate.month': function () {
      this.firstDayInLastMonth();
      setTimeout(() => {
        this.getFirstDay();
      }, 100);
    }
  },
  computed: {
    isEdit () {
      return !!this.medicalId;
    },
    currentMonthDays () {
      return new Date(this.currentDate.year, this.currentDate.month, 0).getDate();
    },
    prevMonth () {
      return new Date(this.currentDate.year, this.currentDate.month - 1, 0).getDate();
    },
    dayNames () {
      return CalendarUtils.getDayNames(this.startDate, this.daysCount);
    },
    currentDay () {
      const now = new Date();
      return (now.getDate() + ' ' + (this.monthShort[now.getMonth()]) + ' - ' + (this.weekDayNames[now.getDay() - 1]))
    },
    startDate () {
      return [this.currentDate.year, this.currentDate.month, this.currentDate.date].map(n => n < 10 ? '0' + n : n).join('-');
    },
    prevMonthDays () {
      let year = this.currentDate.month === 1 ? this.currentDate.year - 1 : this.currentDate.year;
      let month = this.currentDate.month === 1 ? 12 : this.currentDate.month;
      return new Date(year, month, 0).getDate();
    },
    firstMonthDay () {
      let firstDay = new Date(this.currentDate.year, this.currentDate.month, 1).getDate();
      if (this.dayPrev === 'poniedziałek') firstDay = 0;
      if (this.dayPrev === 'wtorek') firstDay = 1;
      if (this.dayPrev === 'środa') firstDay = 2;
      if (this.dayPrev === 'czwartek') firstDay = 3;
      if (this.dayPrev === 'piątek') firstDay = 4;
      if (this.dayPrev === 'sobota') firstDay = 5;
      if (this.dayPrev === 'niedziela') firstDay = 6;
      return firstDay;
    },
  },
  methods: {
    clearPatientData () {
      this.data.patient_id = 0;
      this.data.name = '';
      this.data.last_name = '';
      this.data.pesel = '';
      this.data.phone = '';
      this.data.duration = 0;
    },
    getSinglePatient (patientID) {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/item/' + patientID,
        outputKey: 'patient',
        params: {
          pagination: false
        },
      });
    },
    singlePatient (singleId) {
      this.getSinglePatient(singleId)
      if (this.patient) {
        setTimeout(() => {
          this.data.pesel = this.patient.pesel;
          this.data.phone = this.patient.phone;
          this.data.last_name = this.patient.last_name;
          this.data.name = this.patient.name;
        }, 500);
      }
    },
    checkValueForModal () {
      if (this.data.visit_date && this.data.patient_id && this.data.service_id && this.data.institution_id) {
        this.textOpenModal = true;
      }
    },
    showModalInfoPatient() {
      this.isModalPatientInfoVisible = true;
    },
    closeModalPatientInfo() {
      this.isModalPatientInfoVisible = false;
    },
    closeCalendarPatient() {
      this.showCalendarPatient = false;
    },
    openCalendarPatient() {
      this.showCalendarPatient = true;
    },
    newData () {
      if (this.dataValue.patient_id || this.reservationPatient) {
        if (this.reservationPatient) {
          this.data.patient_id = this.reservationPatient.id;
          this.data.name = this.reservationPatient.name;
          this.data.last_name = this.reservationPatient.last_name;
          this.data.pesel = this.reservationPatient.pesel;
          this.data.phone = this.reservationPatient.phone;
          this.data.duration = this.reservationPatient.duration;
        }
        if (this.popupDate === false && !this.reservationPatient) {
          if (this.dataValue.user_id) {
            this.data.user_id = this.dataValue.user_id;
            this.data.user_name = this.dataValue.name + ' ' + this.dataValue.last_name;
            this.data.date = this.dataValue.date_start.slice(0, 10);
            this.data.hour = this.dataValue.date_start.slice(11, 16);
            this.data.duration = this.dataValue.duration;
          }
        } else {
          this.singlePatient(this.dataValue.patient_id ? this.dataValue.patient_id : this.reservationPatient.id)
        }
      } else {
        this.data.patient_id = this.dataValue.patient_id;
        this.data.pesel = this.dataValue.pesel;
        this.data.phone = this.dataValue.phone;
        this.data.name = this.dataValue.name;
        this.data.last_name = this.dataValue.last_name;
        this.data.user_id = this.dataValue.user_id;
        this.data.date = this.dataValue.date_start.slice(0, 10);
        this.data.hour = this.dataValue.date_start.slice(11, 16);
        this.data.duration = this.dataValue.duration;
      }
    },
    changeForCurrentDate () {
      if (this.data.date.slice(8, 10) === '01') {
        this.currentDate.date = 1
      }
      if (this.data.date.slice(8, 10) === '02') {
        this.currentDate.date = 2
      }
      if (this.data.date.slice(8, 10) === '03') {
        this.currentDate.date = 3
      }
      if (this.data.date.slice(8, 10) === '04') {
        this.currentDate.date = 4
      }
      if (this.data.date.slice(8, 10) === '05') {
        this.currentDate.date = 5
      }
      if (this.data.date.slice(8, 10) === '06') {
        this.currentDate.date = 6
      }
      if (this.data.date.slice(8, 10) === '07') {
        this.currentDate.date = 7
      }
      if (this.data.date.slice(8, 10) === '08') {
        this.currentDate.date = 8
      }
      if (this.data.date.slice(8, 10) === '09') {
        this.currentDate.date = 9
      } else {
        this.currentDate.date = this.data.date.slice(8, 10);
      }
      this.currentDate.month = this.dataValue.date_start.slice(5, 7);
      this.currentDate.year = this.dataValue.date_start.slice(0, 4);
    },
    getIndexFromHours () {
      const hours = this.availableHours;
      const checkId = this.data.hour;
      let index = null;
      for (let i = 0; i < hours.length; i++) {
        if (checkId === hours[i].hour) {
          if (i === 0) {
            index = '0'
          } else {
            index = i
          }
          this.indexEditData = index;
          this.spinnerHourEdit = false;
        }
      }
    },
    getUserHours () {
      const users = this.users;
      const checkId = this.data.user_id;
      let name = '';
      for (let i = 0; i < users.length; i++) {
        if (checkId === users[i].id) {
          name = users[i].name + ' ' + users[i].last_name
        }
        this.userName = name;
        this.spinnerHourEdit = false;
      }
    },
    getInstitution () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/item/' + this.institutionId,
        outputKey: 'institution',
        params: {
          pagination: false
        },
      });
    },
    getService () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/item/' + this.serviceId,
        outputKey: 'service',
        params: {
          pagination: false
        },
      });
    },
    editUser () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        outputKey: 'users',
        params: {
          pagination: false
        },
      });
    },
    scrollIntoId () {
      const el = document.getElementById('button-accept');
      el.scrollIntoView({ behavior: 'smooth' });
    },
    selectReservationDate (date, hour, indexBase, index, key, workerSelectID) {
      this.data.date = date;
      this.data.hour = hour;
      if (key === 'next') {
        this.indexEditData = null;
        if (this.$refs[workerSelectID][0].selectedValue[0]) {
          this.data.user_id = this.$refs[workerSelectID][0].selectedValue[0].id;
          this.data.user_name = this.$refs[workerSelectID][0].selectedValue[0].name;
          this.selectHourIndexNextErr = false;
          if (this.popupDate && this.popupDateStart) {
            setTimeout(() => {
              this.newData();
            }, 200);
          }
          setTimeout(() => {
            this.scrollIntoId();
          }, 200);
        } else {
          this.selectHourIndexNextErr = true;
          this.data.user_id = ''
        }
        this.selectHourDay = false;
        this.selectHourBox = true;
        this.selectHourIndexNextBase = indexBase;
        this.selectHourIndexNext = index;
      }
      if (key === 'hours') {
        this.indexEditData = null;
        if (this.$refs[workerSelectID][0].selectedValue[0]) {
          this.data.user_id = this.$refs[workerSelectID][0].selectedValue[0].id;
          this.data.user_name = this.$refs[workerSelectID][0].selectedValue[0].name;
          this.selectHourIndexNextErr = false;
          if (this.popupDate && this.popupDateStart) {
            setTimeout(() => {
              this.newData();
            }, 200);
          }
          setTimeout(() => {
            this.scrollIntoId();
          }, 200);
        } else {
          this.selectHourIndexNextErr = true;
          this.data.user_id = ''
        }
        this.selectHourDay = true;
        this.selectHourBox = false;
        this.selectHourIndexNextBase = indexBase;
        this.selectHourIndexNext = index;
      }
    },
    openSummary () {
      this.showModalSummary = true;
    },
    closeSummary () {
      this.showModalSummary = false;
    },
    openCalendar () {
      this.showCalendar = true;
    },
    closeCalendar () {
      this.showCalendar = false;
      this.spinnerHours = false;
    },
    checkAvailableHours (i) {
      let data = this.prepareData();
      this.selectHourIndexNextErr = false;
      this.selectHourIndexNext = null;
      this.disableOptions = true;
      if (i === 1) {
        this.containerKey += 1;
        this.spinnerDays = true;
        this.$http.post('/visits/get-next-days', data).then(response => {
          this.availableDays = response.data.data;
          this.selectedHours();
        }).then(() => {
          this.classDays = true;
          this.spinnerDays = false;
          this.disableOptions = false;
          setTimeout(() => {
            this.newData();
          }, 200);
        }).catch(error => {
          console.log(error);
        });
      }
      if (i === 0) {
        this.containerKey += 1;
        this.spinnerHours = true;
        this.$http.post('/visits/get-available-hours', data).then(response => {
          this.availableHours = response.data.data;
          this.selectedHoursDay();
        }).then(() => {
          this.classDays = false;
          this.disableOptions = false;
          this.spinnerDays = false;
          this.spinnerHourEdit = false;
          this.closeCalendar();
          setTimeout(() => {
            this.newData();
          }, 200);
        }).catch(error => {
          console.log(error);
        });
      }
    },
    checkAvailableHoursEdit (value) {
      let data = {
        user_id: this.dataValue.userId,
        institution_id: this.dataValue.institution_id,
        service_id: this.dataValue.service_id,
        visit_id: this.dataValue.id,
        duration: this.dataValue.duration,
      };
      if (value === 1) {
        data.visit_date = this.currentDate.year + '-' + this.currentDate.month + '-' + this.currentDate.date;
      } else {
        data.visit_date = this.dataValue.date_start.slice(0, 10)
      }
      this.spinnerHours = true;
      this.$http.post('/visits/get-available-hours', data).then(response => {
        this.availableHours = response.data.data;
        this.selectedHoursDay();
      }).then(() => {
        this.spinnerDays = false;
        this.closeCalendar();
        setTimeout(() => {
          this.newData();
          setTimeout(() => {
            this.getIndexFromHours();
            this.getUserHours();
            if (value !== 1) {
              this.changeForCurrentDate();
            }
          }, 200);
        }, 200);
      }).catch(error => {
        console.log(error);
      });
    },
    selectedHours () {
      this.selectHourBox = true;
      this.selectHourDay = false;
      this.selectHourNext = !this.selectHourNext;
    },
    selectedHoursDay () {
      this.selectHourDay = true;
      this.selectHourBox = false;
      this.selectHourNextDay = !this.selectHourNextDay;
    },
    prepareData () {
      return {
        user_id: this.userId,
        institution_id: this.institutionId,
        service_id: this.serviceId,
        visit_date: this.startDate,
        duration: this.duration,
      };
    },
    dateUp () {
      this.keySelect += 1;
      if (this.currentDate.date === this.currentMonthDays) {
        this.currentDate.date = 1;
        this.monthUp();
        this.checkAvailableHours(0);
      } else {
        this.currentDate.date += 1;
        this.checkAvailableHours(0);
      }
    },
    dateDown () {
      this.keySelect += 1;
      if (this.currentDate.date === 1) {
        this.currentDate.date = this.prevMonthDays;
        this.monthDown();
        this.checkAvailableHours(0);
      } else {
        this.currentDate.date -= 1;
        this.checkAvailableHours(0);
      }
    },
    monthUp () {
      if (this.currentDate.month === 12) {
        this.currentDate.month = 1;
        this.currentDate.year += 1;
      } else {
        this.currentDate.month += 1;
      }
    },
    monthDown () {
      if (this.currentDate.month === 1) {
        this.currentDate.month = 12;
        this.currentDate.year -= 1;
      } else {
        this.currentDate.month -= 1;
      }
    },
    firstDayInLastMonth () {
      let month = this.monthNumber[this.currentDate.month - 1];
      let year = this.currentDate.year;
      this.firstDayPrev = (year + '-' + month + '-01')
    },
    getFirstDay () {
      this.dayPrev = new Date(this.firstDayPrev.toString()).toLocaleDateString(undefined, { weekday: 'long' });
    },
    checkTheMonthNumber () {
      if ((this.currentDate.date === 1) || (this.currentDate.date === 2) ||
              (this.currentDate.date === 3) || (this.currentDate.date === 4) ||
              (this.currentDate.date === 5) || (this.currentDate.date === 6) ||
              (this.currentDate.date === 7) || (this.currentDate.date === 9)) {
        this.currentDateCopyDate = '0' + this.currentDate.date
      } else {
        this.currentDateCopyDate = this.currentDate.date
      }
    },
    checkSundays () {
      this.day = new Date(this.currentDate.year + '-' + this.monthNumber[this.currentDate.month - 1] + '-' + this.currentDateCopyDate).toLocaleDateString(undefined, { weekday: 'long' });
    },
    getCurrentDate () {
      let today = new Date();
      this.currentDate.date = today.getDate();
      this.currentDate.month = today.getMonth() + 1;
      this.currentDate.year = today.getFullYear() + this.currentDate.yearAdd;
    },
    getCurrentDateEdit () {
      this.disableOptions = false;
      this.disableDate = false;
      this.indexEditData = null;
      this.getCurrentDate();
      setTimeout(() => {
        this.checkAvailableHoursEdit(1);
      }, 200);
    },
    submitForm (value) {
      let formDataToSend = value !== 'reservation' ? this.prepareFormDataToSend() : this.prepareFormDataToSendReservation();
      let endpointUrl = this.isEdit ? '/visits/update/' + this.medicalId : '/visits/store';

      FormUtils.submit(this, {
        endpoint: !this.popupDate ? endpointUrl : '/visits/update/' + this.dataValue.id,
        formData: formDataToSend,
        successTitle: 'Zapisano wizytę',
        successText: 'Wybrana wizyta została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje wizyty nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          if (this.popupDate) {
            this.reload();
            this.popupCloseDate();
            this.popupClose();
          }
          if (this.patientPopup) {
            this.closeModal();
            setTimeout(() => {
              this.$router.push('/wizyty')
            }, 200);
          } else {
            this.$router.push('/wizyty')
          }
        }
      });
    },
    prepareFormDataToSendReservation () {
      return {
        user_id: this.data.user_id,
        institution_id: this.institutionId,
        service_id: this.serviceId,
        date_start: this.data.date + ' ' + this.data.hour,
        waiting: 0,
        patient_id: this.reservationPatient.id === '' ? 0 : this.reservationPatient.id,
        name: this.reservationPatient.name,
        last_name: this.reservationPatient.last_name,
        pesel: this.reservationPatient.pesel,
        phone: this.reservationPatient.phone,
        duration: this.dataValue.duration,
        number_of_people: this.numberOfPeople
      };
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        user_id: this.data.user_id,
        institution_id: this.institutionId,
        service_id: this.serviceId,
        date_start: this.data.date + ' ' + this.data.hour,
        duration: this.data.duration,
        waiting: 0,
        number_of_people: this.numberOfPeople
      };
      if (this.reservationId) {
        formDataToSend.reservation_list_id = this.reservationId;
      }
      if (!this.patientPopup) {
        formDataToSend.patient_id = this.dataValue.patient_id === '' ? 0 : this.dataValue.patient_id;
      }
      if (this.patientPopup) {
        formDataToSend.pesel = this.data.pesel;
        formDataToSend.phone = this.data.phone;
        formDataToSend.name = this.data.name;
        formDataToSend.last_name = this.data.last_name;
        if (this.popupDate) {
          formDataToSend.patient_id = this.patientId === '' ? 0 : this.patientId;
        } else {
          formDataToSend.patient_id = this.data.patient_id === '' ? 0 : this.data.patient_id;
        }
      }
      if (!this.patientPopup) {
        formDataToSend.pesel = this.dataValue.pesel;
        formDataToSend.phone = this.dataValue.phone;
        formDataToSend.name = this.dataValue.name;
        formDataToSend.last_name = this.dataValue.last_name;
      }
      return formDataToSend;
    },
  }
}
</script>

<style lang="scss">
  @import '../../../assets/scss/visit-popup.scss';
  @import '../../../assets/scss/visits-form-patient';
</style>
